import React, { useState, useEffect, useCallback } from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

const SearchInput = ({ onSearch, onClear, placeholder = "Search...", debounceMs = 300, style = {} }) => {
  const [searchValue, setSearchValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');

  // Debounce the search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, debounceMs);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue, debounceMs]);

  // Trigger search when debounced value changes
  useEffect(() => {
    if (debouncedValue) {
      onSearch(debouncedValue);
    } else if (debouncedValue === '' && searchValue === '') {
      // Only clear if both are empty (user cleared the input)
      if (onClear) {
        onClear();
      }
    }
  }, [debouncedValue]);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleClear = () => {
    setSearchValue('');
    setDebouncedValue('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <TextField
      value={searchValue}
      onChange={handleChange}
      placeholder={placeholder}
      variant="standard"
      style={{ marginLeft: 10, marginRight: 10, minWidth: 200, ...style }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: searchValue && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={handleClear}
              aria-label="clear search"
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;
